import { ViewPaneElement } from 'atomicComponents/ViewPaneElement';
import { ViewContainer } from 'tabview/ViewContainer';
import type { ContextShape } from '@ardoq/data-model';
import type { ActiveViews } from 'streams/views/mainContent/activeView$';
import { isComponentIdIncludedInContextByFilter } from '@ardoq/component-interface';
import { getRelevantComponentIds } from '@ardoq/graph';
import type {
  APIComponentAttributes,
  ArdoqId,
  ViewIds,
} from '@ardoq/api-types';

export type ViewPane = 'main' | 'secondary';

export const getViewPaneOfClickedElement = (
  clickedElement?: Element | null
): ViewPane | null => {
  if (clickedElement?.closest(`${ViewPaneElement}:last-child`)) {
    return 'secondary';
  }
  if (clickedElement?.closest(`${ViewPaneElement}, ${ViewContainer}`)) {
    return 'main';
  }
  return null;
};

export const getViewIdOfViewPane = (
  viewPane: ViewPane | null,
  { mainViewId, secondaryViewId }: ActiveViews
): ViewIds | null => {
  if (viewPane === 'secondary') return secondaryViewId;
  if (viewPane === 'main') return mainViewId;
  return null;
};

export const getStartSetForWorkspaceMode = (
  context: ContextShape,
  childrenByParent: Map<ArdoqId, APIComponentAttributes[]>
) =>
  context.componentId &&
  isComponentIdIncludedInContextByFilter(context.componentId)
    ? [context.componentId]
    : getRelevantComponentIds({ ...context, childrenByParent });

export function* includeAncestors<T extends { parent: T | null }>(
  node: T
): Generator<T> {
  yield node;
  if (node.parent) {
    yield* includeAncestors(node.parent);
  }
}
